<div class="bottom tooltip in">
    <div class="tooltip-wrapper">
        <div class="tooltip-arrow"></div>
        <div class="tooltip-inner" [innerHTML]="tooltipHtml()"></div>
    </div>
</div>
